//#region src/domain/view-port/view-port-breakpoints.ts
var ViewPortBreakpoint = /* @__PURE__ */ function(ViewPortBreakpoint) {
	ViewPortBreakpoint[ViewPortBreakpoint["SMARTPHONE"] = 568] = "SMARTPHONE";
	ViewPortBreakpoint[ViewPortBreakpoint["TABLET"] = 768] = "TABLET";
	ViewPortBreakpoint[ViewPortBreakpoint["DESKTOP"] = 1200] = "DESKTOP";
	return ViewPortBreakpoint;
}({});
//#endregion
export { ViewPortBreakpoint };

//# sourceMappingURL=view-port-breakpoints.js.map